import React, { useState, useEffect } from "react";
import { FiSearch } from "react-icons/fi";
import { MdVerified } from "react-icons/md";
import { useLazyGetProductListQuery } from "../../../State/Api/AddPurchaseApiSlice";
import CreateNewProduct from "../CreateNewProduct";

const ProductSelectModal = ({ open, onClose, onSelect }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [products, setProducts] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showCreateProduct, setShowCreateProduct] = useState(false);

  const [triggerGetProducts, { isFetching }] = useLazyGetProductListQuery();

  // 🔹 Search product logic
  useEffect(() => {
    if (!searchTerm.trim()) {
      setProducts([]);
      return;
    }

    const fetchProducts = async () => {
      try {
        const pharmaId = localStorage.getItem("userUniqueID");
        const result = await triggerGetProducts({
          pharmaId,
          productname: searchTerm,
        }).unwrap();
        setProducts(Array.isArray(result) ? result : []);
      } catch (err) {
        console.error("Error fetching products:", err);
        setProducts([]);
      }
    };

    const debounce = setTimeout(fetchProducts, 400);
    return () => clearTimeout(debounce);
  }, [searchTerm, triggerGetProducts]);

  if (!open) return null;

  const handleRowClick = (product, index) => {
    setSelectedRow(index);
    onSelect({
      productName: product.productName,
      productID: product.productID,
      cmpnyName: product.cmpnyName || "",
      mrp: product.mrp || "",
      unitsPerPack: product.unitsPerPack || "", 
    });
    onClose();
  };

  return (
    <>
      {!showCreateProduct && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={onClose}
        >
          <div
            style={{
              width: "950px",
              background: "#fff",
              borderRadius: "10px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              maxHeight: "90vh",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                padding: "26px 18px 10px 18px",
              }}
            >
              <div>
                <h3 style={{ fontSize: "18px", margin: 0, color: "#1d1d1d", fontWeight: "600" }}>
                  Select a Product
                </h3>
                <p style={{ fontSize: "13px", color: "#777", marginTop: "4px" }}>
                  Start typing to search for products
                </p>
              </div>

              {/* ✅ Navigation to Create New */}
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <button className="gradient-button" onClick={() => setShowCreateProduct(true)}>
                  Create New
                </button>
                <button
                  onClick={onClose}
                  style={{
                    fontSize: "18px",
                    border: "none",
                    background: "none",
                    color: "#444",
                    cursor: "pointer",
                  }}
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Search bar */}
            <div style={{ padding: "16px", borderBottom: "1px solid #eee" }}>
              <div style={{ position: "relative", width: "280px" }}>
                <input
                  type="text"
                  placeholder="Search product name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px 36px 8px 10px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    fontSize: "14px",
                  }}
                />
                <FiSearch
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#555",
                    fontSize: "18px",
                  }}
                />
              </div>
            </div>

            {/* Table */}
            <div style={{ overflowY: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#f7f7f7ff" }}>
                    <th style={thStyle}>PRODUCT'S NAME/COMPANY</th>
                    <th style={thStyle}>PACK</th>
                    <th style={thStyle}>STATUS</th>
                    <th style={thStyle}>MRP</th>
                    <th style={thStyle}>SALE RATE</th>
                    <th style={thStyle}>NET RATE</th>
                    <th style={thStyle}>LOCATION</th>
                  </tr>
                </thead>
                <tbody>
                  {isFetching ? (
                    <tr>
                      <td colSpan="7" style={emptyStyle}>Loading...</td>
                    </tr>
                  ) : products.length > 0 ? (
                    products.map((prod, i) => (
                      <tr
                        key={i}
                        style={{
                          background: selectedRow === i ? "#ebfcebff" : i % 2 === 0 ? "#fff" : "#f9f9f9",
                          borderBottom: "1px solid #eee",
                          cursor: "pointer",
                          transition: "background 0.2s",
                        }}
                        onClick={() => handleRowClick(prod, i)}
                      >
                        <td style={tdStyle}>
                          <div style={{ fontWeight: 700, color: "#232224", display: "flex" }}>
                            {prod.productName}
                            <MdVerified
                              style={{
                                color: "#2a8a12ff",
                                fontSize: "16px",
                                marginLeft: "8px",
                              }}
                            />
                          </div>
                          <div style={{ fontSize: "12px", color: "#888" }}>{prod.companyName}</div>
                        </td>
                        <td style={tdStyle}>{prod.pack ?? "-"}</td>
                        <td style={tdStyle}>
  {prod.status ? (
    <span
      style={{
        backgroundColor:
          prod.status === "IN STOCK"
            ? "#22c55e"
            : prod.status === "OUT OF STOCK"
            ? "#ef4444"
            : "#f59e0b",
        color: "white",
        padding: "2px 8px",
        borderRadius: "12px",
        fontSize: "12px",
        fontWeight: 600,
        display: "inline-block",
        minWidth: "70px",
        textAlign: "center",
      }}
    >
      {prod.status}
    </span>
  ) : (
    "-"
  )}
</td>
                        <td style={tdStyle}>₹{prod.mrp ?? "-"}</td>
                        <td style={tdStyle}>{prod.saleRate ?? "-"}</td>
                        <td style={tdStyle}>{prod.netRate ?? "-"}</td>
                        <td style={tdStyle}>{prod.location ?? "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" style={emptyStyle}>
                        {searchTerm.trim()
                          ? "No products found"
                          : "Start typing to search for products"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Create New Product modal */}
      {showCreateProduct && (
        <CreateNewProduct
          show={showCreateProduct}
          onClose={() => setShowCreateProduct(false)}
          onCreated={(created) => {
            // 👇 Pass back to ProductTable
            onSelect({
              productName: created.productName,
              productID: created.productID,
              cmpnyName: created.cmpnyName || "",
              mrp: created.mrp || "",
              unitsPerPack: created.unitsPerPack || "",
               pack: created.unitsPerPack || created.pack || "",
            });
            setShowCreateProduct(false); // go back to product list
            onClose(); // close modal stack
          }}
        />
      )}
    </>
  );
};

const thStyle = {
  textAlign: "left",
  padding: "10px 14px",
  fontSize: "13px",
  fontWeight: 600,
  color: "#555",
  borderBottom: "1px solid #ddd",
};

const tdStyle = {
  padding: "10px 14px",
  fontSize: "13px",
  fontWeight: 700,
  color: "#232224",
  verticalAlign: "top",
};

const emptyStyle = {
  textAlign: "center",
  padding: "20px",
  color: "#777",
  fontSize: "13px",
};

export default ProductSelectModal;
